import ReactDOM from 'react-dom';
import MyApp from './ApolloProvider';
import './styles/app.css';

ReactDOM.render(<MyApp />, document.getElementById('root'));
